import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const headingSm = css`
  font-family: var(${themeVariables.typography.heading.fontFamily});
  font-weight: var(${themeVariables.typography.heading.fontWeight});
  letter-spacing: var(${themeVariables.typography.heading.letterSpacing});
  font-size: var(${themeVariables.typography.heading.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.heading.sizes.sm.lineHeight});
`;

export const root = css`
  grid-column: span 12;
  margin: 0 calc(-1 * var(${themeVariables.spacing.sm}));
`;

export const heading = css`
  ${headingSm};
  text-align: center;
  margin: 0 0 var(${themeVariables.spacing.md}) 0;

  svg {
    display: block;
    margin: 0 auto;
    width: 270px;
    height: auto;
    color: var(${themeVariables.colors.content.brand});
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 0 var(${themeVariables.spacing.lg}) 0;
    `,
  )}

  span {
    display: block;
    margin: 0 auto var(${themeVariables.spacing.sm}) auto;

    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        margin: 0 auto var(${themeVariables.spacing.md}) auto;
      `,
    )}
  }
`;

export const scrollable = css`
  overflow-x: auto;
  scrollbar-width: none;
  padding: 0 var(${themeVariables.spacing.sm});
`;

export const list = css`
  display: flex;
  align-items: stretch;
  margin: 0;
  width: 750px;
  padding: 0 0 var(${themeVariables.spacing.md}) 0;
  column-gap: var(${themeVariables.spacing.lg});

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: 100%;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0 0 var(${themeVariables.spacing.lg}) 0;
    `,
  )}
`;

export const item = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${themeVariables.spacing.md});
  flex-basis: 33%;
  list-style-type: none;
  margin: 0;
  border: 1px solid var(${themeVariables.colors.stroke.interactive});
  border-radius: var(${themeVariables.spacing.xs});
  width: 215px;
  padding: var(${themeVariables.spacing.md});
  box-shadow: 0 8px 16px var(${themeVariables.colors.stroke.default});

  h5 {
    margin: 0;
    font-family: var(${themeVariables.typography.heading.fontFamily});
    font-size: var(${themeVariables.typography.heading.sizes.sm.fontSize});
    line-height: var(${themeVariables.typography.heading.sizes.sm.lineHeight});
    color: var(${themeVariables.colors.content.brand});
  }

  p {
    margin: 0;
    font-family: var(${themeVariables.typography.body.fontFamily});
    font-size: var(${themeVariables.typography.body.sizes.md.fontSize});
    line-height: var(${themeVariables.typography.body.sizes.md.lineHeight});
    color: var(${themeVariables.colors.content.default});
  }
`;

export const itemHeader = css`
  display: flex;
  justify-content: space-between;
  margin: 0;
  font-family: var(${themeVariables.typography.heading.fontFamily});
  font-size: var(${themeVariables.typography.heading.sizes.lg.fontSize});
  line-height: var(${themeVariables.typography.heading.sizes.lg.lineHeight});
  color: var(${themeVariables.colors.content.brand});

  img {
    width: 32px;
  }
`;

export const itemLink = css`
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
  text-decoration: none;
`;

export const serviceRating = css`
  text-align: center;

  h3 {
    margin: 0 0 var(${themeVariables.spacing.xs}) 0;
    ${headingSm};
  }

  a {
    display: block;
    margin: 0 auto;
    max-width: 270px;
  }

  img {
    display: block;
  }
`;
